import { Template, Component, Attribute } from '@scoutgg/ftw/source/lib'
import { Gamescorekeeper } from '../../models'
import config from '@scoutgg/ftw/source/services/config'
import router from '@scoutgg/ftw/source/services/router.service'
import template from './api-browser.jade'
import pick from 'lodash/pick'
import chunk from 'lodash/chunk'
import deburr from 'lodash/deburr'
import debounce from 'lodash/debounce'
import uniqBy from 'lodash/uniqBy'
import IO from 'socket.io-client'

import '@scoutgg/ftw/source/atoms/tabs/tabs'
import '@scoutgg/ftw/source/atoms/tab/tab'
import '@scoutgg/ftw/source/atoms/icons/icons'
import '@scoutgg/ftw/source/atoms/link/link'
import '@scoutgg/ftw/source/atoms/button/button'
import '@scoutgg/ftw/source/atoms/calendar/calendar'
import '@scoutgg/ftw/source/atoms/form-control/form-control'

const SPORTS = [
  'csgo',
  'lol',
]
const TABS = [
  'competitions',
  'competition',
  'fixture',
  'liveFeed',
]
const WS_NAMESPACES = {
  gamescorekeeper: 'payload',
}
const DATE_FORMAT = 'YYYY-MM-DD'
const TIME_FORMAT = 'HH:mm:ss'
let EVENTS = []

@Component('sporty')
@Template(template)
@Attribute('api', String)
@Attribute('sport', String)
@Attribute('tab', String)
@Attribute('id', Number)
export default class ApiBrowser extends HTMLElement {
  created() {
    this.defaultFilters = {
      gamescorekeeper: {
        competition: {
          from: this.moment().subtract(2, 'months').toString(),
          to: this.moment().add(2, 'months').toString(),
          status: '',
        },
      },
    }

    this.data = {
      gamescorekeeper: {
        statuses: [
          'scheduled',
          'started',
          'cancelled',
          'ended',
          'forfeited',
        ],
        competitions: {
          rows: [],
          filter: Object.assign({}, this.defaultFilters.gamescorekeeper.competitions || {}),
          page: 0,
          perPage: 45,
          sort: 'startDate',
          dir: 'desc',
          columns: [
            'id',
            'name',
            'sportAlias',
            'startDate',
            'endDate',
          ],
        },
        competition: {
          rows: [],
          filter: Object.assign({}, this.defaultFilters.gamescorekeeper.competition),
          competition: null,
          page: 0,
          perPage: 50,
          sort: 'scheduledStartTime',
          dir: 'desc',
          columns: [
            'id',
            'feed',
            'scheduledStartTime',
            'startTime',
            'endTime',
            'participants',
            'format',
            'status',
            'tie',
            'winnerId',
          ],
        },
        fixture: {
          fixture: null,
          filter: Object.assign({}, this.defaultFilters.gamescorekeeper.fixture || {}),
          columns: [
            'id',
            'feed',
            'winnerId',
            'status',
            'format',
            'competition',
            'scheduledStartTime',
            'startTime',
            'endTime',
            'sport',
            'participants',
            'maps',
          ],
        },
        liveFeed: {
          events: [],
          filter: Object.assign({}, this.defaultFilters.gamescorekeeper.liveFeed || {}),
          fixture: null,
          columns: {
            csgo: {
              index: '#',
              mapNumber: 'Map #',
              halfNumber: 'Half',
              roundNumber: 'Round',
              timestamp: 'Time',
              name: 'Name',
              mapName: 'Map name',
              winnerId: 'Winner',
              sourceTeamId: 'Source team',
              targetTeamId: 'Target team',
              planterId: 'Planter ID',
              planterName: 'Planter name',
              defuserId: 'Defuser ID',
              defuserName: 'Defuser name',
              weapon: 'Weapon',
              headshot: 'HS',
              killer: 'Killer',
              victim: 'Victim',
              assister: 'Assister',
              participants: 'Participants',
            }
          },
          fixtureColumns: {
            csgo: [
              'id',
              'winnerId',
              'status',
              'format',
              'competition',
              'scheduledStartTime',
              'startTime',
              'endTime',
              'sport',
              'participants',
              'maps',
            ],
          },
          paused: false,
          page: 0,
          perPage: 20,
          totalEvents: 0,
        },
      },
    }
  }

  async attached() {
    if(!this.sport) {
      return router.go('apis', {
        api: this.api,
        sport: 'csgo',
      })
    }

    if(!this.tab) {
      return router.go('apis', {
        api: this.api,
        sport: this.sport,
        tab: 'competitions',
      })
    }

    if(this.tab === 'competitions') {
      await this.showCompetitions()
    }

    if(this.tab === 'competition' && this.id) {
      await this.loadCompetition()
    }

    if(this.tab === 'fixture' && this.id) {
      await this.loadFixture()
    }

    if(this.tab === 'liveFeed' && this.id) {
      await this.loadLiveFeed()
    }

    window.addEventListener('beforeunload', (e) => this.onBeforeUnload(e))
  }

  onBeforeUnload(e) {
    e.preventDefault()
    this.leaveRooms()
    delete e.returnValue
  }

  detached() {
    window.removeEventListener('beforeunload', (e) => this.onBeforeUnload(e))
    this.leaveRooms()
  }

  changed() {
    const apiData = this.data[this.api]

    Object.assign(apiData.liveFeed, {
      events: [],
      filter: this.defaultFilters[this.api][namespace] || {},
      fixture: null,
      currentRoundTime: null,
      currentPlantTime: null,
      page: 0,
      totalEvents: 0,
    })

    Object.assign(apiData.competition, {
      fixtures: [],
      filter: this.defaultFilters[this.api][namespace] || {},
      competition: null,
      page: 0,
    })

    Object.assign(apiData.competitions, {
      competitions: [],
      filter: this.defaultFilters[this.api][namespace] || {},
      page: 0,
    })

    Object.assign(apiData.fixture, {
      fixture: null,
      filter: this.defaultFilters[this.api][namespace] || {},
    })
  }

  leaveRooms() {
    if(!this.socket) return
    this.socket.leaveRooms([this.data[this.api].liveFeed.fixture?.id])
  }

  async loadHistoricFeed() {
    if(this.api === 'gamescorekeeper') {
      const { events = [] } = await Gamescorekeeper
        .load(`feeds/${this.id}`) || {}

      this.handleLivePayload(events)
    }
  }

  async loadLiveFeed() {
    this.toggleLoading('liveFeed')

    Object.assign(this.data[this.api].liveFeed, {
      fixture: null,
      page: 0,
      totalEvents: 0,
    })

    let fixture

    if(this.api === 'gamescorekeeper') {
      fixture = await Gamescorekeeper.load(`fixtures/${this.id}`)
      if(!fixture) return
      this.data[this.api].liveFeed.fixture = fixture

      const status = fixture?.status?.toLowerCase()

      if(['cancelled', 'forfeited'].includes(status)) return
      if(status === 'ended') {
        // Load historic feed if the match is more than 1 day old. This is
        // an arbitrary number not based on anything.
        if(
          fixture.endTime &&
          this.moment().diff(this.moment(fixture.endTime), 'days') >= 1
        ) {
          return this.loadHistoricFeed()
        }
      }
    }

    await this.socketSetup()
    await this.socket.joinRooms([this.id])
  }

  pauseFeed() {
    this.data[this.api].liveFeed.paused = !this.data[this.api].liveFeed.paused
    this.render()
  }

  async handleLivePayload(wsData) {
    if(this.tab !== 'liveFeed' || !wsData) {
      return this.toggleLoading('liveFeed', false)
    }

    const feed = this.data[this.api].liveFeed

    if(feed.events.find(event => event.sortIndex === wsData.sortIndex)) {
      return
    }

    const prepEvent = (event, index) => {
      return Object.assign(pick(
        event[WS_NAMESPACES[this.api]] || {},
        Object.keys(feed.columns[this.sport]).filter(c => c !== 'index')
      ), {
        index: index + 1,
        sortIndex: event.sortIndex,
      })
    }

    if(Array.isArray(wsData)) {
      const events = wsData.map((event, index) => prepEvent(event, index))
      feed.totalEvents = events.length
      feed.events = events.reverse()
    } else {
      const event = prepEvent(wsData, feed.totalEvents)
      feed.totalEvents++
      feed.events.unshift(event)
    }

    await new Promise(resolve => setTimeout(() => resolve(), 1000))

    this.toggleLoading('liveFeed', false)
  }

  linkTo(params) {
    return this.link('apis', Object.assign(params, {
      api: this.api,
      sport: this.sport,
      ...params,
    }))
  }

  async showCompetitions() {
    if(this.api === 'gamescorekeeper') {
      const { competitions } = await Gamescorekeeper.load('competitions', {
        sport: this.sport || 'csgo',
      }) || []

      Object.assign(this.data[this.api].competitions, {
        rows: competitions || [],
      })
    }
  }

  async loadCompetition(page = 0) {
    this.toggleLoading('competition')
    this.setPage(page, 'competition')

    let { perPage, filter } = this.data[this.api].competition

    if(this.api === 'gamescorekeeper') {
      const load = async () => {
        if(!this.data[this.api].competition.competition) {
          const { competitions } = await Gamescorekeeper.load('competitions', {
            sport: this.sport || 'csgo',
          }) || []

          Object.assign(this.data[this.api].competition, {
            competition: competitions.find(c => c.id === this.id)
          })

          this.render()
        }

        const { fixtures = [] } = await Gamescorekeeper
          .load(`fixtures`, {
            page: page + 1,
            pageCount: perPage,
            competitionId: this.id,
            status: filter.status,
            sport: this.sport,
            from: this.moment(filter.from).toString(),
            to: this.moment(filter.to).toString(),
          }) || {}

        this.data[this.api].competition.rows = fixtures
        return this.toggleLoading('competition')
      }

      load()
    }
  }

  async loadFixture() {
    if(this.api === 'gamescorekeeper') {
      const data = await Gamescorekeeper.load(`fixtures/${this.id}`) || {}

      Object.assign(this.data[this.api].fixture, {
        fixture: data,
      })
    }
  }

  async toggleLoading(n, state, cb) {
    if(state || state === false) {
      this.data[this.api][n].loading = state
    } else {
      this.data[this.api][n].loading = !this.data[this.api][n].loading
    }
    this.render(() => {
      if(typeof cb === 'function') cb()
    })
  }

  async setTab(tab, id) {
    const params = {
      api: this.api,
      sport: this.sport,
      tab: tab,
    }

    if(id) {
      params.id = id
    }

    router.go('apis', params)
  }

  async setSport(sport) {
    router.go('apis', {
      api: this.api,
      sport: sport,
    })
  }

  async setPage(page, context) {
    Object.assign(this.data[this.api][context], { page })
    this.render()
  }

  displayValue(v) {
    return v === null || typeof v == undefined
      ? '-'
      : v
  }

  resetFilter(namespace) {
    Object.assign(this.data[this.api][namespace], {
      filter: Object.assign({}, this.defaultFilters[this.api][namespace] || {}),
      page: 0,
    })

    this.render()
  }

  filterOn(namespace, key, value) {
    if(!value) {
      delete this.data[this.api][namespace].filter[key]
    } else {
      this.data[this.api][namespace].filter[key] = value
    }

    Object.assign(this.data[this.api][namespace], {
      page: 0,
    })

    this.render()
  }

  eventClass(row) {
    if(this.sport === 'csgo') {
      const side = this.side(row.killer || row.assister)

      switch(row.name) {
        case 'kill':
          if(side === 'ct') {
            return 'ct'
          }
          if(side === 'terrorist') {
            return 'terrorist'
          }
        case 'flash_assist':
        case 'assist':
          if(side === 'ct') {
            return 'ct-hue'
          }
          if(side === 'terrorist') {
            return 'terrorist-hue'
          }
        case 'bomb_exploded':
          return 'terrorist'
        case 'bomb_planted':
          return 'terrorist-hue'
        case 'bomb_defused':
          return 'ct-hue'
        case 'round_started':
          return 'round-started'
        case 'round_ended':
          return 'round-ended'
        case 'half_started':
          return 'half-started'
        case 'half_ended':
          return 'half-ended'
        case 'map_started':
          return 'map-started'
        case 'map_ended':
          return 'map-ended'
        case 'round_voided':
        case 'half_voided':
        case 'map_voided':
          return 'voided'
        default:
          return ''
      }
    }

    return ''
  }

  side(column = {}) {
    if(this.sport === 'csgo') {
      return column.side?.toLowerCase() || ''
    }
    return ''
  }

  columnize(str) {
    return str
      .replace(/([A-Z])/g, '.')
      .split('.')[0]
  }

  sanitize(str = '') {
    return deburr(str).toLowerCase().trim()
  }

  socketSetup() {
    this.rooms = new Set()
    this.socket = IO(config.ws, { transports: ['websocket'] })

    this.socket.joinRooms = (uids) => {
      console.log('joining rooms: ', uids)
      uids.forEach(uid => {
        if(!this.rooms.has(uid)) {
          this.rooms.add(uid)
        }
      })

      this.socket.emit('subscribe:socketman', this.api, Array.from(this.rooms))
    }

    this.socket.leaveRooms = () => {
      const uids = Array.from(this.rooms)
      console.log('leaving all rooms', uids)

      this.socket.off(WS_NAMESPACES[this.api], (e) => this.handleLivePayload(e))
      this.rooms = new Set()
      this.socket.emit('unsubscribe:socketman', this.api, uids)
    }

    this.socket.on('connect', () => {
      console.log('connected to socketman')
    })

    this.socket.on('disconnect', () => {
      console.log('disconnected from socketman')
      this.socket.connect()
    })

    this.socket.on(WS_NAMESPACES[this.api], (e) => this.handleLivePayload(e))
  }

  genericFilter(namespace, paginated = true) {
    const { filter, perPage, rows, sort, dir } = this.data[this.api][namespace]
    const filterKeys = Object.keys(filter)

    let filtered = rows
      .sort((a, b) => {
        if(dir < 0) {
          return a[sort] - b[sort]
        }
        return b[sort] - a[sort]
      })

    if(filterKeys.length) {
      filtered = filtered
        .filter(item => {
          return filterKeys.every(key => {
            switch(key) {
              case 'id':
                return +item[key] === +filter[key]
              case 'winner':
                if(this.api === 'gamescorekeeper') {
                  const { winnerId, participants } = item
                  const winner = participants?.find(p => p.id === winnerId)
                  return this.sanitize(winner?.name)
                    .includes(this.sanitize(filter[key]))
                }
                break
              case 'participant':
                if(this.api === 'gamescorekeeper') {
                  const { participants } = item
                  return participants?.find(p => {
                    return this.sanitize(p.name)
                      .includes(this.sanitize(filter[key]))
                  })
                }
                break
              default:
                return this.sanitize(item[key])
                  .includes(this.sanitize(filter[key]))
            }
          })
        })
    }

    if(!paginated) {
      return filtered
    }
    return chunk(filtered, perPage)
  }

  get tabs() {
    return TABS
  }

  get sports() {
    return SPORTS
  }

  get dateFormat() {
    return DATE_FORMAT
  }

  get timestampFormat() {
    return `${DATE_FORMAT} ${TIME_FORMAT}`
  }

  get filteredCompetitions() {
    return this.genericFilter('competitions')
  }

  get filteredLiveEvents() {
    const { events, filter, perPage } = this.data[this.api].liveFeed

    if(this.data[this.api].liveFeed.paused) {
      return chunk(EVENTS, perPage)
    }

    const filterKeys = Object.keys(filter)
    let filteredEvents

    if(!filterKeys.length) {
      filteredEvents = events
    } else {
      const deepKeys = {
        csgo: [
          'killer',
          'victim',
          'assister',
        ],
      }

      filteredEvents = events
        .filter(event => {
          return filterKeys.filter(k => deepKeys[this.sport]?.includes(k))
            ?.every(key => {
              return this.sanitize(event[key]?.name)
                .includes(this.sanitize(filter[key]))
            })
        })
        .filter(event => {
          return filterKeys.filter(k => !deepKeys[this.sport].includes(k))
            ?.every(key => {
              if(!isNaN(event[key])) {
                return +event[key] === +filter[key]
              }
              return this.sanitize(event[key])
                .includes(this.sanitize(filter[key]))
            })
        })
    }

    EVENTS = filteredEvents

    return chunk(EVENTS, perPage)
  }
}
